module.exports = __webpack_public_path__ + "img/4ARTS_AZUL_E_BRANCO.0bac7c50.png";